/**
 * Countries for the company lookup (README "Company lookup"): every ISO 3166-1
 * alpha-2 code with its English short name (249), plus XK (Kosovo, the
 * user-assigned code GLEIF uses). The page offers them in a searchable list;
 * the server accepts only these codes.
 */
export const COUNTRIES: Readonly<Record<string, string>> = {
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua & Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia & Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "St. Barthélemy",
  BM: "Bermuda",
  BN: "Brunei",
  BO: "Bolivia",
  BQ: "Caribbean Netherlands",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo - Kinshasa",
  CF: "Central African Republic",
  CG: "Congo - Brazzaville",
  CH: "Switzerland",
  CI: "Côte d’Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czechia",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia & South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong SAR China",
  HM: "Heard & McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "St. Kitts & Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "St. Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "St. Martin",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar (Burma)",
  MN: "Mongolia",
  MO: "Macao SAR China",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "St. Pierre & Miquelon",
  PN: "Pitcairn Islands",
  PR: "Puerto Rico",
  PS: "Palestinian Territories",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Réunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "St. Helena",
  SI: "Slovenia",
  SJ: "Svalbard & Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "São Tomé & Príncipe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Eswatini",
  TC: "Turks & Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Türkiye",
  TT: "Trinidad & Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "U.S. Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Vatican City",
  VC: "St. Vincent & Grenadines",
  VE: "Venezuela",
  VG: "British Virgin Islands",
  VI: "U.S. Virgin Islands",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis & Futuna",
  WS: "Samoa",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  XK: "Kosovo",
};

export const COUNTRY_CODES: readonly string[] = Object.keys(COUNTRIES);

export const isCountry = (cc: unknown): cc is string => typeof cc === 'string' && Object.hasOwn(COUNTRIES, cc);

export const countryName = (cc: string | null | undefined): string => (cc && isCountry(cc.toUpperCase()) ? COUNTRIES[cc.toUpperCase()] : String(cc ?? ''));

/** Other names people type for a country (searching "UK", "USA", "Deutschland" finds it). */
export const COUNTRY_ALIASES: Readonly<Record<string, string[]>> = {
  GB: ['UK', 'Great Britain', 'Britain', 'England', 'Scotland', 'Wales', 'Northern Ireland'],
  US: ['USA', 'United States of America', 'America'],
  DE: ['Deutschland', 'Germany'],
  DK: ['Danmark'],
  NO: ['Norge'],
  SE: ['Sverige'],
  FI: ['Suomi'],
  NL: ['Holland', 'Nederland', 'The Netherlands'],
  CH: ['Schweiz', 'Suisse', 'Svizzera'],
  AT: ['Österreich'],
  ES: ['España'],
  IT: ['Italia'],
  FR: ['République française'],
  AE: ['UAE', 'Emirates'],
  KR: ['South Korea', 'Korea'],
  CZ: ['Czech Republic'],
  TR: ['Turkey'],
  CI: ["Ivory Coast", "Cote d'Ivoire"],
};

/** Countries matching what a person typed: by code, name or alias, names starting with the text first. */
export function searchCountries(q: string, limit = 300): Array<{ code: string; name: string }> {
  const fold = (s: string) => s.normalize('NFKD').replace(/\p{M}+/gu, '').toLowerCase();
  const t = fold(q.trim());
  const all = COUNTRY_CODES.map((code) => ({ code, name: COUNTRIES[code] })).sort((a, b) => a.name.localeCompare(b.name, 'en'));
  if (!t) return all.slice(0, limit);
  const scored: Array<{ code: string; name: string; s: number }> = [];
  for (const c of all) {
    const names = [c.name, ...(COUNTRY_ALIASES[c.code] ?? [])].map(fold);
    let s = 0;
    if (fold(c.code) === t) s = 4;
    else if (names.some((n) => n === t)) s = 4;
    else if (names.some((n) => n.startsWith(t))) s = 3;
    else if (names.some((n) => n.split(/[\s,()-]+/).some((w) => w.startsWith(t)))) s = 2;
    else if (names.some((n) => n.includes(t))) s = 1;
    if (s) scored.push({ ...c, s });
  }
  return scored.sort((a, b) => b.s - a.s || a.name.localeCompare(b.name, 'en')).slice(0, limit).map(({ code, name }) => ({ code, name }));
}

/** The browser's country from its language settings ("da-DK" → DK, "en-GB" → GB, "de" → DE), only ever a suggestion. */
export function localeCountry(languages: readonly string[]): string | null {
  for (const l of languages) {
    try {
      const region = new Intl.Locale(l).maximize().region;
      if (region && isCountry(region)) return region;
    } catch {
      /* not a language tag */
    }
  }
  return null;
}

/**
 * What the registration number is called in a country, for the optional
 * field's label, plus an example. Elsewhere: "Company registration number".
 */
const REG_LABELS: Record<string, { label: string; example?: string; short: string }> = {
  DK: { label: 'CVR number', example: '12345678', short: 'CVR' },
  GB: { label: 'Companies House number', example: '01234567', short: 'Company no.' },
  DE: { label: 'Handelsregisternummer', example: 'HRB 12345', short: 'HR no.' },
  NO: { label: 'Organisasjonsnummer', example: '123456789', short: 'Org. no.' },
  SE: { label: 'Organisationsnummer', example: '556123-4567', short: 'Org. no.' },
  US: { label: 'EIN or state file number', example: '12-3456789', short: 'Reg. no.' },
  FR: { label: 'SIREN', example: '123 456 789', short: 'SIREN' },
  NL: { label: 'KvK number', example: '12345678', short: 'KvK' },
};

export function regNumberLabel(cc: string | null | undefined): { label: string; example: string | null; short: string } {
  const r = cc ? REG_LABELS[cc.toUpperCase()] : undefined;
  return r ? { label: r.label, example: r.example ?? null, short: r.short } : { label: 'Company registration number', example: null, short: 'Reg. no.' };
}
